"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _date_formatter = require("../../../packages/common-utilities/src/date_formatter.js");

var _date_formatter2 = _interopRequireDefault(_date_formatter);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _ramda = require("ramda");

var _string_utility = require("../../../packages/common-utilities/src/string_utility.js");

var _string_utility2 = _interopRequireDefault(_string_utility);

var _tooltipText = require("./global_components/tooltipText");

var _collection_utility = require("common-utilities/src/collection_utility");

var _reactIntl = require("react-intl");

var _accessibility_utility = require("../../../packages/common-utilities/src/accessibility_utility");

var _accessibility_utility2 = _interopRequireDefault(_accessibility_utility);

var _functional_utility = require("../../../packages/common-utilities/src/functional_utility");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MorningStarSummaryHeader = function (_React$PureComponent) {
  _inherits(MorningStarSummaryHeader, _React$PureComponent);

  function MorningStarSummaryHeader(props) {
    _classCallCheck(this, MorningStarSummaryHeader);

    var _this = _possibleConstructorReturn(this, (MorningStarSummaryHeader.__proto__ || Object.getPrototypeOf(MorningStarSummaryHeader)).call(this, props));

    _this.tooltipId = "pdpSummaryMorningstarRatingPopUp";
    _this.handleDisclosureIconClick = _this.handleDisclosureIconClick.bind(_this);
    _this.handleMorningStarDisclaimer = _this.handleMorningStarDisclaimer.bind(_this);
    return _this;
  }

  _createClass(MorningStarSummaryHeader, [{
    key: "renderIcon",
    value: function renderIcon(titleText) {
      var _this2 = this;

      var _props = this.props,
          disclosure = _props.disclosure,
          useTooltipWrapper = _props.useTooltipWrapper;

      var tooltipId = "pdpSummaryMorningstarRating";

      if (!disclosure || (0, _ramda.isNil)(disclosure[tooltipId])) {
        return null;
      }

      if ((0, _functional_utility.doesFormattingRulesContain)("SHOW_HARDCODED_MORNINGSTAR_INFORMATION", this.props, ["formattingRules"])) {
        var disclosureText = _string_utility2.default.getLocalizedString(this.props.intl, null, "pdp-summary-header-morningstar-rating-text", { year: new Date().getFullYear() });
        if (!(0, _ramda.isNil)(disclosureText) && disclosureText !== 'pdp-summary-header-morningstar-rating-text') {
          disclosure[tooltipId] = disclosureText;
        }
      }

      if (useTooltipWrapper) {
        return (0, _tooltipText.getDisclaimerText)({
          className: "display-inline",
          text: _react2.default.createElement("span", {
            tabIndex: 0,
            className: "icon-info print-hide margin-left-5",
            role: "button",
            "aria-label": "more information about" + titleText,
            "data-testid": "morningstar-overall-disclosure-icon",
            id: "disclosure-" + tooltipId
          }),
          tooltipText: disclosure[tooltipId],
          useOffsetLeftForArrowPosition: true
        });
      }

      return _react2.default.createElement(
        "span",
        {
          id: "disclosure-" + tooltipId,
          tabIndex: 0,
          className: "icon-info print-hide margin-left-5",
          role: "button",
          "aria-label": "more information about" + titleText,
          "data-testid": "morningstar-overall-disclosure-icon",
          onKeyDown: function onKeyDown(event) {
            return _accessibility_utility2.default.handleEnterClick(_this2, event, _this2.handleDisclosureIconClick.bind(_this2, event, tooltipId, disclosure));
          },
          onClick: function onClick(event) {
            return _this2.handleDisclosureIconClick(event, tooltipId, disclosure);
          }
        },
        " "
      );
    }
  }, {
    key: "handleDisclosureIconClick",
    value: function handleDisclosureIconClick(e, tooltipId, disclosure) {
      var el = e.currentTarget || e.target;
      var elHeight = el.offsetHeight;
      var elWidth = el.parentNode.getBoundingClientRect().left;
      var elRect = el.getBoundingClientRect();
      var arrowHeight = 4;
      var docTop = document.documentElement && document.documentElement.scrollTop || document.body.scrollTop;

      var toolTipWidth = void 0,
          toolTipContentWidth = void 0,
          closeTipPosition = void 0,
          toolTipContentScroll = 'hidden';
      if (disclosure[tooltipId][0].length > 380) {
        if (this.props.breakpoint > 3) {
          elWidth -= 150;
          toolTipWidth = 570;
          toolTipContentWidth = 530;
          closeTipPosition = 530;
        } else {
          toolTipContentScroll = 'auto';
        }
      }
      var elOffset = {
        top: elRect.top + docTop + arrowHeight + elHeight,
        left: elWidth,
        arrowPosition: elRect.left - elWidth - 3,
        toolTipWidth: toolTipWidth,
        toolTipContentWidth: toolTipContentWidth,
        closeTipPosition: closeTipPosition,
        toolTipContentScroll: toolTipContentScroll
      };

      this.props.tooltip.openTooltip(elOffset, disclosure[tooltipId], null, true, e);
    }
  }, {
    key: "handleMorningStarDisclaimer",
    value: function handleMorningStarDisclaimer(e, tooltip, disclosure) {
      if (!(0, _ramda.isNil)(tooltip)) {
        var el = e.currentTarget || e.target;
        var elHeight = el.offsetHeight;
        var elWidth = el.parentNode.getBoundingClientRect().left;
        var elRect = el.getBoundingClientRect();
        var arrowHeight = 4;

        var toolTipWidth = void 0,
            toolTipContentWidth = void 0,
            closeTipPosition = void 0,
            toolTipContentScroll = 'hidden';
        if (disclosure[0].length > 380) {
          if (this.props.breakpoint > 3) {
            toolTipWidth = 600;
            toolTipContentWidth = "auto";
            closeTipPosition = 555;
          } else {
            toolTipContentScroll = 'auto';
          }
        }

        var docTop = document.documentElement && document.documentElement.scrollTop || document.body.scrollTop;

        var elOffset = {
          top: elRect.top + docTop + arrowHeight + elHeight,
          left: elWidth,
          arrowPosition: elRect.left - elWidth + (elRect.right - elRect.left) / 2,
          toolTipWidth: toolTipWidth,
          toolTipContentWidth: toolTipContentWidth,
          closeTipPosition: closeTipPosition,
          toolTipContentScroll: toolTipContentScroll
        };

        this.props.tooltip.openTooltip(elOffset, disclosure, null, true, e);
      }
    }
  }, {
    key: "renderTooltip",
    value: function renderTooltip(tooltipId, disclosure) {
      var _this3 = this;

      var tooltip = this.props.tooltip;

      if (!disclosure) {
        return null;
      }
      return _react2.default.createElement(
        "a",
        {
          tabIndex: 0,
          id: "disclosure-" + tooltipId,
          className: "font-peacock-blue cursor-pointer-blue",
          "data-testid": "morningstar-disclosure-text",
          onKeyDown: function onKeyDown(event) {
            return _accessibility_utility2.default.handleEnterClick(_this3, event, _this3.handleMorningStarDisclaimer.bind(_this3, event, tooltip, disclosure));
          },
          onClick: function onClick(event) {
            return _this3.handleMorningStarDisclaimer(event, tooltip, disclosure);
          }
        },
        this.getMorningstarDisclaimer
      );
    }
  }, {
    key: "getMorningstarRatingInfo",
    value: function getMorningstarRatingInfo(infoType) {
      if (_collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, 'SHOW_MORNINGSTAR_RATING')) {
        return this.props.morningstarRating[0];
      }
      return _collection_utility.CollectionUtility.find(this.props.morningstarRating, function (obj) {
        return obj.periodIndicator === infoType;
      });
    }
  }, {
    key: "getRankNumber",
    value: function getRankNumber(infoType) {
      var info = this.getMorningstarRatingInfo(infoType);
      if ((0, _ramda.isNil)(info)) {
        return null;
      } else {
        return info.rankNumber;
      }
    }
  }, {
    key: "getStarRatings",
    value: function getStarRatings(rankNumber) {
      var isAEM = this.props.isAEM;

      var rowCollection = [];
      var starRenderingValue = isAEM ? rankNumber : 5;
      if (!(0, _ramda.isNil)(rankNumber)) {
        for (var i = 0; i < starRenderingValue; i++) {
          var iconColor = "";
          var noRatingStar = "";
          if (i >= rankNumber) {
            iconColor = " font-slate-grey-3";
            noRatingStar = "-no-star";
          }
          rowCollection.push(_react2.default.createElement("span", { className: "icon-morning_star full width-20 margin-right-8" + iconColor, key: i,
            "data-testid": "morningstar-overall-rating" + noRatingStar, id: "morningstar-overall-rating" }));
        }
        return _react2.default.createElement(
          "div",
          { className: "height-20 display-flex" },
          rowCollection
        );
      } else {
        return _react2.default.createElement(
          "div",
          null,
          "Not Yet Rated"
        );
      }
    }
  }, {
    key: "isMorningStarPresent",
    value: function isMorningStarPresent() {
      for (var i = 0; this.props.morningstarRating && i < this.props.morningstarRating.length; i++) {
        if (this.props.morningstarRating[i].periodIndicator === "OVR" && this.props.morningstarRating[i].rankNumber > 3) {
          return true;
        } else if (_collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, 'SHOW_MORNINGSTAR_RATING') && this.props.morningstarRating[i].rankNumber > 3) {
          return true;
        } else if (_collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, 'SHOW_MORNINGSTAR_RATING_ALWAYS') && this.props.morningstarRating[i].rankNumber > 0) {
          return true;
        }
      }
      return false;
    }
  }, {
    key: "renderCategoryCount",
    value: function renderCategoryCount() {
      if ((0, _ramda.isNil)(this.getMorningstarRatingInfo('OVR').peerGroupCount) || this.getMorningstarRatingInfo('OVR').peerGroupCount === 0 || _collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, 'HIDE_MORNINGSTAR_RATING_CATEGORY_COUNT')) {
        return null;
      }
      return _react2.default.createElement(
        "div",
        { className: "category awards-ratings-info-text",
          "data-testid": "fund-ratings-morningstar-overall-peerGroupCount",
          id: "fund-ratings-morningstar-overall-peerGroupCount" },
        this.getMorningstarRatingInfo('OVR').peerGroupCount + " " + _string_utility2.default.getLocalizedString(this.props.intl, "Funds in Category", "pdp-overview-morningstar-funds-category-label")
      );
    }
  }, {
    key: "renderAsOfDate",
    value: function renderAsOfDate() {
      var isAEM = this.props.isAEM;

      if ((0, _ramda.isNil)(this.getMorningstarRatingInfo('OVR').effectiveDate)) {
        return null;
      }

      var labelKey = (0, _functional_utility.doesFormattingRulesContain)("AWARD_MORNINGSTAR_ALIGNMENT_APAC_JP", this.props, ['formattingRules']) ? "pdp-summary-header-morningstar-as-of" : "label-for-as-of";
      var fontColor = isAEM ? "black" : "off-white";
      var fixedDateSpacing = isAEM ? 120 : 150;
      return _react2.default.createElement(
        "div",
        { className: "category margin-top-10 margin-left-" + fixedDateSpacing + " font-" + fontColor,
          "data-testid": "fund-ratings-morningstar-overall-as-of-date",
          id: "fund-ratings-morningstar-overall-as-of-date" },
        _string_utility2.default.renderFormattedLabel("As of ", labelKey, { role: this.props.role }),
        _date_formatter2.default.getLocalFormattedDate(this.getMorningstarRatingInfo('OVR').effectiveDate)
      );
    }
  }, {
    key: "renderPeerGroupCategory",
    value: function renderPeerGroupCategory() {
      if ((0, _ramda.isNil)(this.props.peerGroupCategory)) {
        return null;
      }
      return _react2.default.createElement(
        "div",
        { className: "category awards-ratings-info-text",
          "data-testid": "fund-ratings-morningstar-overall-category",
          id: "fund-ratings-morningstar-overall-category" },
        _string_utility2.default.renderFormattedLabel("Category: ", "pdp-summary-header-morningstar-category-label", { role: this.props.role }),
        _string_utility2.default.getLocalizedString(this.props.intl, this.props.peerGroupCategory, "pdp-overview-peer-group-category-" + _string_utility2.default.customKebabCase(this.props.peerGroupCategory))
      );
    }
  }, {
    key: "renderMorningStarForHeader",
    value: function renderMorningStarForHeader() {
      var isAEM = this.props.isAEM;

      var widthAdjustment = isAEM ? " width-675" : "";
      if (!this.isMorningStarPresent()) {
        return null;
      }

      var rankNumber = this.getRankNumber('OVR');
      var titleText = _string_utility2.default.getLocalizedString(this.props.intl, "Morningstar Rating: Overall", "pdp-summary-header-morningstar-rating-label");

      return _react2.default.createElement(
        "div",
        { "data-testid": "fund-ratings-morningstar-summary-header-rating",
          className: "display-inline-block text-top print-hide padding-right-20 margin-bottom-40" },
        _react2.default.createElement(
          "div",
          { className: "title font-regular tag margin-bottom-6",
            "data-testid": "fund-ratings-morningstar-overall-label",
            id: "fund-ratings-morningstar-overall-label" },
          _string_utility2.default.renderFormattedLabel("Morningstar Rating: Overall", "pdp-summary-header-morningstar-rating-label", { role: this.props.role }),
          this.renderIcon(titleText)
        ),
        _react2.default.createElement(
          "div",
          { className: "row margin-horizontal-0" },
          _react2.default.createElement(
            "div",
            { className: "font-light font-25 margin-top-5 margin-bottom-5 float-left",
              "data-testid": "fund-ratings-morningstar-overall-rating",
              id: "fund-ratings-morningstar-overall-rating" },
            this.getStarRatings(rankNumber)
          ),
          _react2.default.createElement(
            "span",
            { className: 'sr-only' },
            rankNumber,
            " out of 5 Star Morningstar overall rating"
          ),
          this.renderAsOfDate()
        ),
        _react2.default.createElement(
          "div",
          { className: "row margin-horizontal-0" + widthAdjustment },
          this.renderCategoryCount(),
          this.renderPeerGroupCategory(),
          this.renderDisclaimerText
        )
      );
    }
  }, {
    key: "render",
    value: function render() {
      return this.renderMorningStarForHeader();
    }
  }, {
    key: "getMorningstarDisclaimer",
    get: function get() {
      return _string_utility2.default.renderFormattedLabel("", "pdp-summary-header-morningstar-disclaimer-toggle-text", { role: this.props.role });
    }
  }, {
    key: "renderDisclaimerText",
    get: function get() {
      var _props2 = this.props,
          disclosure = _props2.disclosure,
          additionalClassName = _props2.additionalClassName,
          useTooltipWrapper = _props2.useTooltipWrapper,
          isAEM = _props2.isAEM;

      var widthAdjustment = isAEM ? " width-percent-5 margin-top-15" : "";
      if (_collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, 'HIDE_MORNINGSTAR_RATING_CATEGORY_DISCLAIMER')) {
        return null;
      }

      if (useTooltipWrapper) {
        return (0, _tooltipText.getDisclaimerText)({
          className: "font-peacock-blue cursor-pointer-blue category font-slate-grey" + widthAdjustment,
          text: this.getMorningstarDisclaimer,
          tooltipText: disclosure.pdpSummaryMorningstarRatingPopUp,
          dataTestId: "morningstar-disclaimer"
        });
      }
      return _react2.default.createElement(
        "div",
        {
          className: "category font-slate-grey awards-ratings-info-text " + additionalClassName,
          "data-testid": "morningstar-disclaimer",
          id: "morningstar-disclaimer"
        },
        this.renderTooltip(this.tooltipId, disclosure.pdpSummaryMorningstarRatingPopUp)
      );
    }
  }]);

  return MorningStarSummaryHeader;
}(_react2.default.PureComponent);

exports.default = (0, _reactIntl.injectIntl)(MorningStarSummaryHeader, { withRef: true });